<template>
  <notifications
    :width="breakpoints.smAndDown ? '343px' : '400px'"
    position="top right"
  >
    <template #body="props">
      <div class="notification">
        <div class="flex justify-between gap-4">
          <AppIcon
            :name="`notification_${props.item.type}_icon`"
            class="shrink-0"  
          />
          <div class="grow">
            <span class="title">
              {{ title[props.item.type] || getContent('notification.title_info') }}
            </span>
            <p
              class="text"
              v-html="props.item?.text"
            />
          </div>
          <AppIcon
            name="notification_close_icon"
            class="cursor-pointer shrink-0"
            @click="props.close"
          />
        </div>
      </div>
    </template>
  </notifications>
</template>

<script setup>
const breakpoints = useBreakpoints()
const title = {
  success: getContent('notification.title_success'),
  error: getContent('notification.title_error'),
  warning: getContent('notification.title_warning'),
  info: getContent('notification.title_info')
}
</script>

<style lang="scss" scoped>
.vue-notification-group {
  right: 20px !important;
  top: 20px !important;
}

.notification {
  padding: 24px;
  border-radius: 15px;
  background-color: $black;
  backdrop-filter: blur(30px);
  margin-bottom: 20px;

  .title {
    color: $white;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
  }

  .text {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    max-height: 80px;
    overflow-y: auto;
    color: $gray-100;
    overflow-x: hidden;
  }
}

@media only screen and (max-width: $sm) {
  .vue-notification-group {
    right: 16px !important;
  }
}
</style>